module.exports = __webpack_public_path__ + "media/vc_photo.63c1ed3c.mp4";